import script from "./CallWindow.vue?vue&type=script&setup=true&lang=js"
export * from "./CallWindow.vue?vue&type=script&setup=true&lang=js"

import "./CallWindow.vue?vue&type=style&index=0&id=71fc2a26&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71fc2a26"]])

export default __exports__